import React, {useState, useEffect} from "react";
import { Table, Button, Form, Col, Row } from "react-bootstrap";
// import { useOrders } from "../OrderContext";
import Pagination from "react-bootstrap/Pagination";
import { fetchReturnedOrders } from "../api/api";
import {useNavigate} from "react-router-dom";
import {AccountingScopeSelect, useAccountingScope} from "./Accounting/accountingscope";

const ReturnedOrders = () => {
   const scope = useAccountingScope();
   const [returns, setReturns] = useState([]);
   const [searchTerm, setSearchTerm] = useState('');
   const [currentPage, setCurrentPage] = useState(1);
   const [totalCount, setTotalCount] = useState(0);
   const [startDate, setStartDate] = useState("");
   const [endDate, setEndDate] = useState("");

   const pageSize = 20;
   const navigate = useNavigate();

   const handleBack = () => {
       navigate(-1);
   }

   const loadReturns = async (page = 1) => {
       if (scope.loadingScope || !scope.storeId) return;
        try {
            const response = await fetchReturnedOrders(page, {
                searchTerm: searchTerm,
                start_date: startDate,
                end_date: endDate,
                store_id: scope.storeId,
            }, pageSize);
            setReturns(response.results);
            setTotalCount(response.count);

        } catch (error) {
            console.error('Error fetching returned orders:', error);
            setReturns([]);
            setTotalCount(0);
        }
   };

    useEffect(() => {
        loadReturns(currentPage);
    }, [currentPage, scope.loadingScope, scope.storeId]);

    useEffect(() => {
        setCurrentPage(1);
        loadReturns(1);
    }, [searchTerm, startDate, endDate, scope.loadingScope, scope.storeId]);

    const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

    const maxLinks = 5;

    // calculate dynamic window around current page
    let startLink = Math.max(totalPages - 2, 1);
    let endLink = startLink + maxLinks - 1;

    // prevent overflow past total pages
    if (endLink > totalPages) {
        endLink = totalPages;
        startLink = Math.max(endLink - maxLinks + 1, 1);
    }

    const pageNumbersToShow = [];
    for (let i = startLink; i <= endLink; i++) {
        pageNumbersToShow.push(i);
    }

    return (
        <>
            <div className="back-button-container">
                <Button variant="danger" onClick={handleBack}>Back</Button>
            </div>
            <div>

                <h1>Returned Orders</h1>

                <Form className="mb-3">
                    <Row>
                        <Col md={3}>
                            <AccountingScopeSelect scope={scope} label="Return Scope" />
                        </Col>
                        <Col md={4}>
                            <Form.Control
                                type="text"
                                placeholder="Search by Order Number"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Control
                                type="date"
                                value={startDate}
                                onChange={(e) => {
                                    setStartDate(e.target.value);
                                    setCurrentPage(1); // reset to first page on date change
                                }}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Control
                                type="date"
                                value={endDate}
                                onChange={(e) => {
                                    setEndDate(e.target.value);
                                    setCurrentPage(1); // reset to first page on date change
                                }}
                            />
                        </Col>
                    </Row>
                </Form>

                {/*Table*/}
                {returns.length > 0 ? (
                    <>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Order Number</th>
                                    <th>Customer</th>
                                    <th>Return Date</th>
                                    <th>Processed By</th>
                                    <th>Total Returned Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {returns.map(ret => (
                                    <tr key={ret.id}>
                                        <td>{ret.order_number}</td>
                                        <td>{ret.customer_name || 'Walk-in'}</td>
                                        <td>{ret.return_date.slice(0, 10)}</td>
                                        <td>{ret.processed_by || "_"}</td>
                                        <td>{parseFloat(ret.total_return_amount).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        {/* PAGINATION */}
                        <div className="mt-4 d-flex justify-content-center">
                            <Pagination>
                                <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />

                                <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                 disabled={currentPage === 1} />

                                {pageNumbersToShow.map(pageNum => (
                                    <Pagination.Item key={pageNum} active={pageNum === currentPage}
                                                     onClick={() => setCurrentPage(pageNum)}>
                                        {pageNum}
                                    </Pagination.Item>
                                ))}

                                <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                 disabled={currentPage === totalPages} />

                                <Pagination.Last onClick={() => setCurrentPage(totalPages)}
                                                    disabled={currentPage === totalPages} />
                            </Pagination>
                        </div>
                    </>

                ) : (
                    <p>No returned orders for the selected range</p>
                )}
            </div>
        </>
    );
};

export default ReturnedOrders;